import React from 'react';
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";

const ShoppingCartInstallationQuestion = (props) => {
  return (
    <div
      className={"scart-content__question" + (props.questionNoClicked ? " scart-content__question--translate" : "")}>
      <p className="scart-content__question-text">
        <FormattedMessage id="shoppingCart.installationQuestion"/>
      </p>
      <div className="scart-content__question-buttons">
        <button className="ui-button2 ui-button2--white" onClick={props.openInstallationView}>
          <FormattedMessage id="shoppingCart.installationQuestionYesButton"/>
        </button>
        <button className="ui-button2 ui-button2--white" onClick={props.handleNoClick}>
          <FormattedMessage id="shoppingCart.installationQuestionNoButton"/>
        </button>
      </div>
    </div>
  )
};

ShoppingCartInstallationQuestion.propTypes = {
  questionNoClicked: PropTypes.bool.isRequired,
  openInstallationView: PropTypes.func.isRequired,
  handleNoClick: PropTypes.func.isRequired,
}

export default ShoppingCartInstallationQuestion
